/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs.js'

const $nsid = 'app.bsky.feed.searchPosts'

export { $nsid }

/** Find posts matching search criteria, returning views of those posts. Note that this API endpoint may require authentication (eg, not public) for some service providers and implementations. */
const main = l.query(
  $nsid,
  l.params({
    q: l.string(),
    sort: l.optional(
      l.withDefault(l.string<{ knownValues: ['top', 'latest'] }>(), 'latest'),
    ),
    since: l.optional(l.string()),
    until: l.optional(l.string()),
    mentions: l.optional(l.string({ format: 'at-identifier' })),
    author: l.optional(l.string({ format: 'at-identifier' })),
    lang: l.optional(l.string({ format: 'language' })),
    domain: l.optional(l.string()),
    url: l.optional(l.string({ format: 'uri' })),
    tag: l.optional(l.array(l.string({ maxLength: 640, maxGraphemes: 64 }))),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 25),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    hitsTotal: l.optional(l.integer()),
    posts: l.array(l.ref<FeedDefs.PostView>((() => FeedDefs.postView) as any)),
  }),
  ['BadQueryString'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
